import { useState } from 'react';
import PageContent, { PageBreadcrumbProps } from '../PageContent';
import { ODataGrid, TitlelessCard } from '../../components';
import { GridCellProps, GridColumn, GridRowClickEvent } from '@progress/kendo-react-grid';
import CTEyeService from '../../services/CTEyeService';
import { routes } from '../../app/routes';
import CTEyeRootSubmenu from './CTEyeRootSubmenu';
import { CTEyeClientResponse } from '../../data/entities';
import { useSharedState } from '../../app/sharedProperty';
import { ApproveClientModal } from './components';
import { formatDateTime } from '../../app/dateHelpers';

export function CTEyePendingApprovals() {
  const title = "Unassigned Agents";
  const breadcrumbs: PageBreadcrumbProps = {
    showHome: true,
    values: [
      { label: "CTEye Agents", url: routes.cteye },
      { label: title }
    ]
  };
  const service = new CTEyeService();
  const submenus = <CTEyeRootSubmenu />;

  const showApproveModalState = useSharedState(false);
  const [selectedClient, setSelectedClient] = useState<CTEyeClientResponse | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const getData = async (oDataQuery: string) => {
    const clients = await service.getUnregisteredClients();
    return {
      "@odata.context": "",
      "@odata.count": clients.length,
      value: clients
    };
  };

  const handleApproveClick = (client: CTEyeClientResponse) => {
    setSelectedClient(client);
    showApproveModalState.setter(true);
  };

  const handleRowClick = (e: GridRowClickEvent) => {
    handleApproveClick(e.dataItem);
  };

  const handleApproveSuccess = () => {
    setSelectedClient(null);
    setRefreshKey(prev => prev + 1);
  };

  const versionCell = (props: GridCellProps) => {
    const version = props.dataItem.runningVersion || '—';
    return <td><code className="text-muted">{version}</code></td>;
  };
  
  const lastSeenCell = (props: GridCellProps) =>{
    return (
      <td className="text-secondary small">
        {props.dataItem.lastSeenDate
          ? formatDateTime(new Date(props.dataItem.lastSeenDate))
          : "—"}
      </td>
    )
  }

  return (
    <PageContent title={title} breadcrumbs={breadcrumbs} submenu={submenus}>
      <TitlelessCard className="p-0" bodyClassName="p-0">
        <ODataGrid 
          key={refreshKey}
          getData={getData}
          onRowClick={handleRowClick}
          pageSize={20}
          pageable={{ buttonCount: 5 }}
          sortable={false}
          filterable={false}
        >
          <GridColumn 
            title="Agent" 
            field="description" 
            filter="text"
          />
          <GridColumn 
            title="Version" 
            field="runningVersion" 
            filter="text"
            cell={versionCell}
          />
          <GridColumn 
            title="Last Seen" 
            field="lastSeenDate" 
            filter="date"
            cell={lastSeenCell}
          />
        </ODataGrid>
      </TitlelessCard>

      <ApproveClientModal
        showState={showApproveModalState}
        client={selectedClient}
        onSuccess={handleApproveSuccess}
      />
    </PageContent>
  );
}

export default CTEyePendingApprovals;